import React, {Component} from 'react'
import styles from './Framer.css'
import {FrameAnimation, FrameStates} from '../../constants/consts-types'
import PropTypes from 'prop-types'
import {TypeColors} from '../../constants/consts-prop-types'
import { isSMKGuide, isGuideLanding } from '../../services/service-utils'

class Framer extends Component {
  static propTypes = {
    state: PropTypes.string.isRequired,
    colors: TypeColors,
    currentRoute: PropTypes.shape({})
  }

  static defaultProps = {
    colors: {
      foreground: 'inherit',
      background: 'currentColor'
    }
  }

  componentDidMount() {
    this.tl = new window.TimelineLite()

    this.animateWithDelay()
  }

  componentDidUpdate(prevProps) {
    const { id } = this.props.currentRoute || {}
    const { id: prevId } = prevProps.currentRoute || {}
    
    if (id && prevId && id !== prevId) {
      this.animateWithDelay()
    }
  }

  animate() {
    const time = .2
    const del = '-=0'

    // window.TweenLite.set(this.tl, {progress: 0})

    // this.tl.stop()
    if(this.left) this.tl.add(window.TweenLite.to(this.left, time, {y: 0, height: '100%', force3D: true}), del)
    if(this.top) this.tl.add(window.TweenLite.to(this.top, time, {width: '100%', force3D: true}), del)
    if(this.right) this.tl.add(window.TweenLite.to(this.right, time, {height: '100%', force3D: true}), del)
    if(this.bottom) this.tl.add(window.TweenLite.to(this.bottom, time, {x: 0, width: '100%', force3D: true}), del)
    window.TweenLite.to(this.tl, 1.7, {progress: 1, ease: window.Power2.easeInOut})
  }

  animateWithDelay() {
    window.TweenLite.set(this.tl, { progress: 0 })
    this.tl.stop()

    setTimeout(() => {
      this.animate()
    }, FrameAnimation.ENTER_DELAY * 0.5)
  }

  getClassName(state) {
    switch (state) {
      case FrameStates.CAMPAIGN:
        return styles.campaign
      case FrameStates.MENU_INIT:
        return styles.menuInit
      case FrameStates.MENU:
        return styles.menu
      case FrameStates.MENU_SUB:
        return styles.menuSub
      case FrameStates.INIT_FRONT:
        return styles.initFront
      case FrameStates.FRONT:
        return styles.front
      case FrameStates.LEAVE_FRONT:
        return styles.leaveFront
      case FrameStates.INIT_SECTION:
        return styles.initSection
      case FrameStates.SECTION:
        return styles.section
      case FrameStates.LEAVE_SECTION:
        return styles.leaveSection
      case FrameStates.INIT_EXHIBITION:
        return styles.initExhibition
      case FrameStates.EXHIBITION:
        return styles.exhibition
      case FrameStates.LEAVE_EXHIBITION:
        return styles.leaveExhibition
      case FrameStates.INFO:
        return styles.info
      case FrameStates.INIT_FACT:
        return styles.initFact
      case FrameStates.FACT:
        return styles.fact
      default:
        return styles.menuInit
    }
  }

  render() {
    const { state: frameState, currentRoute } = this.props

    const styleColor = {
      color: (isSMKGuide(currentRoute) ? 'white' : this.props.colors.foreground)
    }

    const classNames = `${styles[this.props.className]} ${this.getClassName(this.props.state)}`
    const cssGuide = isGuideLanding(currentRoute) && frameState !== FrameStates.MENU
      ? ` ${styles.subBrand_Guide} ${styles.landing}`
      : ''

    return (
      <div className={`${classNames}${cssGuide}`} style={styleColor}>
        <div ref={node => this.top = node} className={styles.top}/>
        <div ref={node => this.right = node} className={styles.right}/>
        <div ref={node => this.bottom = node} className={styles.bottom}/>
        <div ref={node => this.left = node} className={styles.left}/>
      </div>
    )
  }
}

export default Framer



// WEBPACK FOOTER //
// ./src/components/Framer/Framer.js